import { render, staticRenderFns } from "./aerobics-view.vue?vue&type=template&id=b10e4f62&scoped=true&"
import script from "./aerobics-view.vue?vue&type=script&lang=js&"
export * from "./aerobics-view.vue?vue&type=script&lang=js&"
import style0 from "./aerobics-view.vue?vue&type=style&index=0&id=b10e4f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10e4f62",
  null
  
)

export default component.exports